//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { mapActions } from 'vuex'
import stateList from '../../assets/src/usstates.json'
import moment from 'moment'

export default {
  computed: {
    ...mapState([ 'locationList', 'options', 'order' ])
  },
  data() {
    return {
      query: '',
      suggestions: [],
      showMap: false,
      method: 'pickup',
      sortBy: 'nearest',
      states: [],
      cities: [],
      timeout: null,
      searching: false,
      placeholder: 'Search store, city, state, or zip',
      deliveryError: false,
    }
  },
  mounted() {
    let states = []
    // if (this.locationList && this.locationList.length > 0) {      
      // this.locationList.map(l => {
      //   let stateIndex = this.getStateIndex(l.state, states)
      //   if(stateIndex < 0) {
      //     states.push({
      //       abbr: l.state,
      //       name: stateList[l.state],
      //       cities: []
      //     })
      //     stateIndex = states.length - 1
      //   }
      //   let cityIndex = this.getCityIndex(l.city, states[stateIndex].cities)
      //   if(cityIndex < 0) {
      //     states[stateIndex].cities.push({
      //       name: l.city,
      //       locations: []
      //     })
      //     cityIndex = states[stateIndex].cities.length - 1
      //   }
      //   states[stateIndex].cities[cityIndex].locations.push(l)
      //   this.cities.push(l) // add city to master list 
      // })
      // states.map(s => {
      //   s.cities.sort(this.sortCities)
      // })
      // states.sort(this.sortStates)
      // this.states = states
    // }
    this.$nextTick(() => {
      setTimeout(function() {
        document.querySelector('.search-wrapper input').focus() // focus on load
      }, 100)
    })
  },
  methods: {
    ...mapActions([ 'locationSearch' ]),
    switchSearch(type) {
      if(type == 'delivery') {
        this.method = 'delivery'
        this.placeholder = 'Enter a delivery address'
      } else {
        // this.suggestions = []
        this.method = 'pickup'
        this.placeholder = 'Search store, city, state, or zip'
      }
      this.$store.commit('setLocationList', null)
      this.query = ''
    },
    hours(loc) {
      let hours = loc.hours[new Date().getDay()]
      if (hours !== undefined) {
        let time = moment(hours.date + ' ' + hours.close, 'YYYY-MM-DD H:mm').format('h a')
        if (loc.closed) {
          return 'Opens at ' + time
        } else {
          return 'Open until ' + time
        }
      }
    },
    focus() {
      document.querySelector('.search-filter select').focus()
    },
    async search(e) {
      if(this.method == 'pickup') {
        this.showMap = false
        clearTimeout(this.timeout)
        let q = this.query.toLowerCase()
        this.searching = true
        this.showMap = false
        if (q.length <= 3) {
          this.searching = false
          return false // prevent short string search
        }
        this.timeout = setTimeout(function() {
          this.locationSearch({ address: q })
          this.searching = false
        }.bind(this), 700)
      } else if(e.key != 'Shift' && this.query.length > 4) {
        let newAddress = this.query.split(" ")
        let streetNum = /^[0-9]+$/.test(newAddress[0])
        
        if (streetNum) { 
          this.deliveryError = false
          this.$axios({
            method: 'get',
            url: `${window.location.origin}/api/autocomplete`,
            params: {
              query: this.query
            }
          }).then(res => {
            this.suggestions = res.data.features
          }).catch(err => {
            this.resetAutocomplete()
          })
        } else {
          this.deliveryError = true
          this.suggestions = []
          this.$store.commit('setLocationList', null)
        }
      }
    },
    resetAutocomplete() {
      this.suggestions = []
    },
    sortStates(a, b) {
      return a.abbr < b.abbr ? -1 : 1
    },
    sortCities(a, b) {
      return a.name < b.name ? -1 : 1
    },
    async startOrder(loc) {
      let location = await this.$api.getLocation(loc.id)
      if(location) {
        await this.$api.getMenu()
        let order = null
        if(this.order) {
          order = await this.$api.transferOrder()
          if(!order) {
            order = await this.$api.setHandoff('pickup')
          }
          if(order && order.totals.tip > 0) {
            await this.$api.addTip(0)
          }
        } else {
          order = await this.$api.createOrder()
        }
        if(order) {
          if(this.method == 'delivery') {
            let order2 = await this.$api.setAddress(this.$store.state.customer.delivery)
            if(order2) {
              this.$router.push('/order/')
            }
          } else {
            await this.$api.setHandoff('pickup')
            this.$router.push('/order/')
          }
        }
      }
    }
  }
}
